import { Settings } from "@material-ui/icons";
import "./Menu.scss";
import exit from "../../../assets/images/exit.svg";
import { NavLink, useNavigate } from "react-router-dom";
import { useState, useEffect, useRef } from "react";
import useLogout from "../../../hooks/useLogout";
import useAdminUser from "../../../data/useAdminUser";
import useAgencyUser from "../../../data/useAgencyUser";
import { useModerationNotificationsState } from "../../../hooks/useModerationNotifications";
import { getDomainConfig } from "../../../configs/main";

function Menu() {
  const [settings, setSettings] = useState(false);
  const settingsRef = useRef(null);
  const { user: adminUser, isLoading: adminLoading } = useAdminUser();
  const { user: agencyUser, isLoading: agencyLoading } = useAgencyUser();
  const adminToken = localStorage.getItem("admin_token");
  const agencyToken = localStorage.getItem("agency_token");
  const isAdminInAgencyMode = adminToken && agencyToken && !adminLoading && !agencyLoading;
  const user = isAdminInAgencyMode ? agencyUser : (adminUser || agencyUser);
  const isAgencyUser = user?.role === "AGENCY" || isAdminInAgencyMode;
  const isManagerRetargeo = user?.role === "MANAGER_RETARGEO";
  const logout = useLogout();
  const navigate = useNavigate();
  const { count: moderationCount, enabled: showModerationCount } = useModerationNotificationsState();

  const handleReturnToAdmin = () => {
    localStorage.removeItem("agency_token");
    navigate("/admin/agencies");
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (settingsRef.current && !settingsRef.current.contains(event.target)) {
        setSettings(false);
      }
    };

    if (settings) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [settings]);

  return (
    <div className="AdminMenu">
      <div className="AdminLogo">
        <svg
          className="logo"
          width="230"
          height="40"
          viewBox="0 0 230 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_87311_8827)">
            <path
              d="M13.7578 7.09198C15.8105 7.09198 17.3502 7.62751 18.3767 8.69812C19.4028 9.76955 19.9159 11.3399 19.9159 13.4086V16.7311C19.9159 18.8003 19.4028 20.3701 18.3767 21.4411C17.3502 22.5121 15.8105 23.0477 13.7578 23.0477H11.805V32.6503H7.67471V19.3965H11.805H12.4308H13.7578C14.4337 19.3965 14.9407 19.2141 15.2785 18.8491C15.6166 18.4835 15.7858 17.8631 15.7858 16.987V13.1532C15.7858 12.2769 15.6166 11.6559 15.2785 11.2911C14.9407 10.9258 14.4337 10.7432 13.7578 10.7432H12.4308H11.805H7.67471V7.09198H13.7578ZM194.675 18.5932V10.7432V10.0905V7.09198H200.909C203.037 7.09198 204.589 7.57275 205.565 8.53407C206.541 9.49579 207.03 10.9745 207.03 12.9704V14.9783C207.03 17.6073 206.129 19.3356 204.326 20.163C205.303 20.5525 206.004 21.2036 206.429 22.1167C206.855 23.0293 207.068 24.1915 207.068 25.6035V29.5465C207.068 30.2772 207.092 30.8673 207.142 31.3177C207.192 31.7679 207.318 32.2119 207.518 32.6503H203.312C203.162 32.2362 203.062 31.8468 203.012 31.4818C202.962 31.1169 202.937 30.4594 202.937 29.5104V25.4938C202.937 24.3253 202.724 23.4919 202.298 22.9929C201.873 22.4938 201.184 22.2444 200.233 22.2444H198.806V24.9035V32.6503H194.675V24.9035V18.5932ZM198.806 10.7432V18.5932H199.614H200.422C201.247 18.5932 201.866 18.3861 202.28 17.9723C202.693 17.5585 202.899 16.865 202.899 15.8913V13.3722C202.899 12.4473 202.73 11.7778 202.393 11.3639C202.055 10.9503 201.522 10.7432 200.796 10.7432H199.614H198.806ZM1.47778 0.0625H0.445312V10.7432H4.57675V4.07955H224.998V35.6627H4.57675V19.3965H0.445312V39.6797H1.47778H4.57675H224.998H228.096H229.129V0.0625H228.096H224.998H4.57675H1.47778ZM30.6556 32.6503C30.5054 32.2362 30.4057 31.8468 30.3556 31.4818C30.3056 31.1169 30.2798 30.4594 30.2798 29.5104V25.4938C30.2798 24.3253 30.0677 23.4919 29.6417 22.9929C29.2167 22.4938 28.5277 22.2444 27.5765 22.2444H26.1496V32.6503H22.0189V7.09198H28.2524C30.3805 7.09198 31.9325 7.57275 32.9087 8.53407C33.8847 9.49579 34.373 10.9745 34.373 12.9704V14.9783C34.373 17.6073 33.4718 19.3356 31.6696 20.163C32.6456 20.5525 33.3468 21.2036 33.7723 22.1167C34.1979 23.0293 34.4107 24.1915 34.4107 25.6035V29.5465C34.4107 30.2772 34.4355 30.8673 34.4856 31.3177C34.5358 31.7679 34.6608 32.2119 34.8616 32.6503H30.6556ZM26.1496 18.5932H27.7645C28.5904 18.5932 29.2099 18.3861 29.6231 17.9723C30.0361 17.5585 30.2428 16.865 30.2428 15.8913V13.3722C30.2428 12.4473 30.0735 11.7778 29.7355 11.3639C29.3981 10.9503 28.8655 10.7432 28.1396 10.7432H26.1496V18.5932ZM36.7766 13.2261C36.7766 11.1814 37.3144 9.59936 38.3907 8.47922C39.4673 7.36011 41.0196 6.80017 43.0473 6.80017C45.0747 6.80017 46.6275 7.36011 47.7037 8.47922C48.7799 9.59936 49.3181 11.1814 49.3181 13.2261V26.5162C49.3181 28.5606 48.7799 30.143 47.7037 31.2629C46.6275 32.3821 45.0747 32.9421 43.0473 32.9421C41.0196 32.9421 39.4673 32.3821 38.3907 31.2629C37.3144 30.143 36.7766 28.5606 36.7766 26.5162V13.2261ZM40.9068 26.7719C40.9068 28.4512 41.6207 29.2912 43.0473 29.2912C44.4742 29.2912 45.1875 28.4512 45.1875 26.7719V12.9704C45.1875 11.2911 44.4742 10.4509 43.0473 10.4509C41.6207 10.4509 40.9068 11.2911 40.9068 12.9704V26.7719ZM63.9625 18.4108V26.5162C63.9625 28.5852 63.4372 30.1735 62.3856 31.2808C61.3345 32.3882 59.8075 32.9421 57.8045 32.9421C55.8015 32.9421 54.2746 32.3882 53.2236 31.2808C52.1722 30.1735 51.6466 28.5852 51.6466 26.5162V13.2261C51.6466 11.1569 52.1722 9.5686 53.2236 8.46115C54.2746 7.35391 55.8015 6.80017 57.8045 6.80017C59.8075 6.80017 61.3345 7.35391 62.3856 8.46115C63.4372 9.5686 63.9625 11.1569 63.9625 13.2261V15.7089H60.0575V12.9704C60.0575 11.2911 59.3442 10.4509 57.9173 10.4509C56.4907 10.4509 55.7767 11.2911 55.7767 12.9704V26.7719C55.7767 28.427 56.4907 29.2548 57.9173 29.2548C59.3442 29.2548 60.0575 28.427 60.0575 26.7719V22.0618H58.1804V18.4108H63.9625ZM75.2654 32.6503C75.1151 32.2362 75.0154 31.8468 74.9652 31.4818C74.9152 31.1169 74.8899 30.4594 74.8899 29.5104V25.4938C74.8899 24.3253 74.6776 23.4919 74.2515 22.9929C73.8264 22.4938 73.1373 22.2444 72.1861 22.2444H70.7595V32.6503H66.6293V7.09198H72.8623C74.9902 7.09198 76.5424 7.57275 77.5184 8.53407C78.4949 9.49579 78.9831 10.9745 78.9831 12.9704V14.9783C78.9831 17.6073 78.082 19.3356 76.2793 20.163C77.2554 20.5525 77.9565 21.2036 78.3821 22.1167C78.8079 23.0293 79.0206 24.1915 79.0206 25.6035V29.5465C79.0206 30.2772 79.0454 30.8673 79.0955 31.3177C79.146 31.7679 79.271 32.2119 79.4714 32.6503H75.2654ZM70.7595 18.5932H72.3744C73.2001 18.5932 73.8198 18.3861 74.2329 17.9723C74.6459 17.5585 74.8524 16.865 74.8524 15.8913V13.3722C74.8524 12.4473 74.6839 11.7778 74.3458 11.3639C74.0078 10.9503 73.4755 10.7432 72.7495 10.7432H70.7595V18.5932ZM90.9242 32.6503L90.3504 28.9231L90.3387 28.8471L90.2104 28.0131H90.2068L89.2661 22.0684L87.6572 11.6198L85.6672 24.5448H85.6699L85.0749 28.4433L84.428 32.6503H80.6351L84.841 7.09198H90.8862L95.0923 32.6503H90.9242ZM108.573 7.09198H114.318V32.6503H110.413V14.3212L107.559 32.6503H103.654L100.574 14.577V32.6503H96.9698V7.09198H102.715L105.756 25.2385L108.573 7.09198ZM128.887 7.09198H134.633V32.6503H130.728V14.3212L127.873 32.6503H123.969L120.89 14.577V32.6503H117.284V7.09198H123.029L126.071 25.2385L128.887 7.09198ZM146.837 32.6503L146.123 28.0131H146.099L145.549 24.5448H145.56L143.57 11.6198L141.888 22.5447L141.867 22.5478L140.927 28.7076L140.947 28.7084L140.341 32.6503H136.548L140.754 7.09198H146.8L151.004 32.6503H146.837ZM164.485 7.09198V10.7432H160.167V32.6503H156.037V10.7432H151.718V7.09198H164.485ZM170.419 7.09198V32.6503H166.288V7.09198H170.419ZM185.401 26.5162C185.401 28.5852 184.875 30.1735 183.824 31.2808C182.772 32.3882 181.246 32.9421 179.243 32.9421C177.24 32.9421 175.713 32.3882 174.662 31.2808C173.611 30.1735 173.084 28.5852 173.084 26.5162V13.2261C173.084 11.1569 173.611 9.5686 174.662 8.46115C175.713 7.35391 177.24 6.80017 179.243 6.80017C181.246 6.80017 182.772 7.35391 183.824 8.46115C184.875 9.5686 185.401 11.1569 185.401 13.2261V15.7089H181.495V12.9704C181.495 11.2911 180.783 10.4509 179.356 10.4509C177.928 10.4509 177.215 11.2911 177.215 12.9704V26.7719C177.215 28.427 177.928 29.2548 179.356 29.2548C180.783 29.2548 181.495 28.427 181.495 26.7719V23.1205H185.401V26.5162ZM191.672 32.6503H187.692V28.7796H191.672V32.6503ZM213.714 26.8083C213.714 28.4636 214.427 29.2912 215.854 29.2912C217.282 29.2912 217.995 28.4636 217.995 26.8083V7.09198H221.9V26.553C221.9 28.6215 221.374 30.2101 220.322 31.3177C219.271 32.4251 217.744 32.979 215.742 32.979C213.739 32.979 212.212 32.4251 211.16 31.3177C210.11 30.2101 209.583 28.6215 209.583 26.553V7.09198H213.714V26.8083Z"
              fill="url(#paint0_linear_87311_8827)"
            />
          </g>
          <defs>
            <linearGradient
              id="paint0_linear_87311_8827"
              x1="1.60944"
              y1="39.6797"
              x2="228.206"
              y2="-2.14878"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#6B58E0" />
              <stop offset="1" stopColor="#3F73F9" />
            </linearGradient>
            <clipPath id="clip0_87311_8827">
              <rect
                width="229.333"
                height="39.6172"
                fill="white"
                transform="translate(0.445312 0.0625)"
              />
            </clipPath>
          </defs>
        </svg>
        <span>{getDomainConfig().title === 'Programmatic Beta' ? 'DEV Admin panel' : 'Admin panel'}</span>
      </div>
      <div className="admin-menu-container">
        {
          isAgencyUser ? (
            <nav className="menu-nav">
              <NavLink to="/admin/agency-clients">Клиенты</NavLink>
              <NavLink to="/admin/agency-campaigns">Кампании</NavLink>
              <NavLink to="/admin/agency-finance">Финансы</NavLink>
              <NavLink to="/admin/agency-requisites">Реквизиты</NavLink>
            </nav>
          ) : isManagerRetargeo ? (
            <nav className="menu-nav">
              <NavLink to="/admin/clients">Клиенты</NavLink>
            </nav>
          ) : (
            <nav className="menu-nav">
              <NavLink to="/admin/clients">Клиенты</NavLink>
              <NavLink to="/admin/payments">Пополнения</NavLink>
              <NavLink to="/admin/campaigns">Кампании</NavLink>
              <NavLink to="/admin/staff">Сотрудники</NavLink>
              <NavLink to="/admin/reports">Отчеты</NavLink>
              <NavLink to="/admin/logs">История</NavLink>
              <NavLink to="/admin/moderation">
                Модерация
                {showModerationCount && moderationCount > 0 && (
                  <span className="moderation-badge">{moderationCount}</span>
                )}
              </NavLink>
              <NavLink to="/admin/dmp">DMP</NavLink>
              <NavLink to="/admin/ssp">Охватные кампании</NavLink>
              <NavLink to="/admin/campaigns-reports">Отчёт производства</NavLink>
              {
                user && ["ADMIN", "SUPERUSER"].includes(user.role) && (
                  <>
                    <div className="menu-divider"></div>
                    <NavLink to="/admin/agencies">Агентства</NavLink>
                    <NavLink to="/admin/closing-documents">Закрывашки</NavLink>
                    <div className="menu-divider"></div>
                    
                  </>
                )
              }
              {
                user?.role === "SUPERUSER" && (
                  <>
                    <p style={{fontSize: "12px", marginTop: "10px", marginLeft: "10px", color: "#888"}}>Только для superuser`ов</p>
                    <NavLink to="/admin/product-analytics">Аналитика</NavLink>
                    <NavLink to="/admin/reachSettings">Настройки охватов</NavLink>
                    <NavLink to="/admin/dspSettings">Настройки SSP</NavLink>
                  </>
                )
              }
            </nav>
          )
        }
      </div>
      <div className="adminAccount">
        <div className="account">
          {isAdminInAgencyMode && agencyUser && (
            <div className="admin-mode-indicator">
              <div className="admin-mode-content">
                <div className="admin-mode-info">
                  {agencyUser.profile ? (
                    <div className="agency-name">
                      {agencyUser.profile.first_name} {agencyUser.profile.surname}
                    </div>
                  ) : agencyUser.name ? (
                    <div className="agency-name">{agencyUser.name}</div>
                  ) : (
                    <div className="agency-name">Агентство</div>
                  )}
                  {agencyUser.role && (
                    <div className="agency-role">{agencyUser.role}</div>
                  )}
                </div>
                <button
                  type="button"
                  onClick={handleReturnToAdmin}
                  className="return-button"
                >
                  Вернуться
                </button>
              </div>
            </div>
          )}
          <div className="account-info">
            <div className="info">
              <div className="name">
                {isAdminInAgencyMode
                  ? (adminUser?.profile
                    ? `${adminUser.profile.first_name} ${adminUser.profile.surname}`
                    : adminUser?.name || "")
                  : (user?.profile
                    ? `${user.profile.first_name} ${user.profile.surname}`
                    : user?.name || "")}
              </div>
              <span className="role">
                {isAdminInAgencyMode
                  ? (adminUser?.role || "")
                  : (user?.role || "")}
              </span>
            </div>
          </div>
          <div className="account-actions">
            <div className="settings-wrapper" ref={settingsRef}>
              <div
                className="settings"
                onClick={() => setSettings((prev) => !prev)}
              >
                <Settings />
              </div>
              {settings && (
                <div className="settings-dropdown">
                  <div
                    className="settings-item"
                    onClick={() => {
                      navigate("/admin/password-reset");
                      setSettings(false);
                    }}
                  >
                    Сменить пароль
                  </div>
                </div>
              )}
            </div>
            <button type="button" onClick={logout} className="logout">
              <img src={exit} alt="logout" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Menu;
